/* eslint-disable import/no-commonjs */
require('@sitepark/sp-base-js-api/target/sp-base-js-api');
require('@sitepark/sitekit-js/src/main/javascript/Bootstrap');
